import ToolContactImage from '../../images/tool-contact.png'
import ToolPlanImage from '../../images/tool-plan.png'
import ToolPlanWhiteImage from '../../images/tool-plan-white.png'
import React from 'react'
import { useTranslations } from '../../hooks/useTranslations'
import { useToolOverlay } from '../Context/ToolOverlayContext'

const ExpandedToolButton = ({ inverted, onOpenTool }) => {
  const { setContextSectionLimit } = useToolOverlay()
  const translations = useTranslations()

  const openToolSection = (section, label) => {
    setContextSectionLimit(section)
    onOpenTool(label)
  }

  return (
    <div
      className={`fixed flex flex-col md:flex-row px-16 md:px-0 py-10 md:py-0 items-start md:items-center space-y-4 md:space-y-0 md:space-x-6 text-xs bottom-0 md:bottom-auto left-0 md:left-auto top-auto right-0 md:top-8 md:right-8 z-[99] bg-white md:bg-transparent ${
        inverted && 'text-white'
      }`}
    >
      <button
        type="button"
        onClick={() => openToolSection('people', translations.personalContact)}
        className="flex w-full flex-row-reverse md:flex-row items-center justify-end pb-4 md:pb-0 md:space-x-1.5 border-b border-gray-4 md:border-0"
      >
        <span className="whitespace-nowrap">
          {translations.personalContact}
        </span>
        <img
          src={ToolContactImage}
          alt=""
          className="w-auto h-[22px] mr-1.5 md:mr-0"
        />
      </button>
      <button
        type="button"
        onClick={() =>
          openToolSection('planningtool', translations.planningTools)
        }
        className="flex w-full flex-row-reverse md:flex-row items-center justify-end pb-4 md:pb-0 md:space-x-1.5 border-b border-gray-4 md:border-0"
      >
        <span className="whitespace-nowrap">{translations.planningTools}</span>
        <img
          src={inverted ? ToolPlanWhiteImage : ToolPlanImage}
          alt=""
          className="w-auto h-[22px] mr-1.5 md:mr-0"
        />
      </button>
      <button
        type="button"
        onClick={() => openToolSection('emergency', translations.reportFault)}
        className="flex w-full flex-row-reverse justify-end md:flex-row items-center md:space-x-1.5"
      >
        <span className="whitespace-nowrap">{translations.reportFault}</span>
        <div className="w-4 h-4 bg-red rounded-full  mr-1.5 md:mr-0" />
      </button>
    </div>
  )
}

export default ExpandedToolButton
